/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnLeftDown: {
  name: 'arrow-turn-left-down';
  data: string;
} = {
  name: 'arrow-turn-left-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 6a1 1 0 0 1-1 1h-5v8.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L10 15.586V7A2 2 0 0 1 12 5h5a1 1 0 0 1 1 1Z" fill="currentColor"/></svg>`,
};
